module.exports = __webpack_public_path__ + "static/media/faq.0f839257.png";